export default __webpack_public_path__ + "static/media/perro2.343f8962.jpeg";